<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
      activeIndex: 1
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #122e89;
  overflow-x: hidden;
  height: 100%;
}

.el-dialog--center {
  .el-dialog__footer {
    text-align: right !important;
  }
}

.demo-form-inline {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding: 10px 20px;

  .el-form-item {
    margin-bottom: 20px !important;
  }
}

.show-line {
  transform: translateY(-2px);
  margin-right: 5px;
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  -webkit-transform: translateY(-2px);
  -moz-transform: translateY(-2px);
  -ms-transform: translateY(-2px);
  -o-transform: translateY(-2px);
}

.show-rline {
  background: #ff7784;
}

.show-bline {
  background: #86d182;
}

.table_content {
  transform: translateX(0px) !important;
  width: 100%;
  // border: 1px solid rgba(240, 240, 241, 1);
  -webkit-transform: translateX(-20px) !important;
  -moz-transform: translateX(-20px) !important;
  -ms-transform: translateX(-20px) !important;
  -o-transform: translateX(-20px) !important;
}

li {
  padding-left: 15px;
}

.input_width {
  width: 330px;
}

.tranf_x {
  transform: translateX(-11px);
}

.zxdz {
  .el-form-item__label {
    width: 86px !important;
    font-size: 16px !important;
    color: #333333;
  }
}

.dstc {
  // .el-col-5 {
  //   width: 145px;
  // }
  .el-link--inner {
    font-size: 14px;
    color: #326ff6 !important;
  }

  // .el-col-3 {
  //   width: 110px;
  // }
  .el-form-item__label {
    padding-right: 6px;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-date-editor {
    width: 260px !important;
  }
}

.xzsd {
  .el-form-item__content {
    .el-date-editor {
      width: 240px !important;
    }
  }
}

.cftj {
  .el-input__inner {
    width: 100px;
  }
}

.editor-dialog-ruleForm {
  .el-form-item__content {
    margin-left: 0 !important;
    cursor: pointer;
  }
}

.ldtj {
  .el-row {
    padding-left: 50px;

    .el-select {
      .el-input__inner {
        width: 126px;
      }
    }
  }
}

.ldkz {
  .ldzxdz {
    .el-form-item__label {
      width: 92px !important;
      font-size: 16px !important;
      color: #333333;
    }
  }
}

.sfjpb {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.tables-container {
  .el-table__row {
    td {
      padding: 4px !important;
    }
  }
}

.cfDiv {
  .el-form-item__label {
    padding-right: 6px;
  }

  .el-input {
    width: 90px;
  }
}

.LdcfDiv {
  .el-form-item__label {
    padding-right: 6px;
  }

  .el-input__inner {
    width: 120px;
  }

  .seValue {
    .el-input {
      width: 109px;
    }

    .el-input__inner {
      width: 109px;
    }
  }

  .el-icon-remove-outline {
    font-size: 20px;
    position: relative;
    top: 2px;
  }
}

.el-date-editor {
  .el-range-separator {
    width: 11% !important;
  }
}

// .priceManagement-page {
//   height: 100%;
// }
// .table_content1 {
//   width: 100%;
//   border: 1px solid rgba(240, 240, 241, 1);
// }
.cropsManagement-page {
  .avatar-uploader {
    width: 100px;
    height: 100px;

    .el-icon-plus {
      position: absolute;
    }
  }

  .good-container {
    width: 73px !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-item {
    margin-bottom: 20px;
  }
}

.homePage-page {
  .avatar-uploader {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;

    .el-icon-plus {
      position: absolute;
    }
  }

  .good-container {
    width: 73px !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-item {
    margin-bottom: 20px;
  }
}

.el-date-editor .el-range-separator {
  width: 10% !important;
}

.el-dailog_width {
  width: 330px !important;
}

.icom_dailog {
  position: relative;
  top: 10px;
  color: #ff7574;
  margin-right: 4px;
}

.icom_dailog2 {
  position: relative;
  top: 12px;
  left: 11px;
  color: #ff7574;
  margin-right: 4px;
}

.table-title-title {
  .el-button {
    margin-right: 8px !important;
    margin-top: 8px !important;
  }
}

.table-title-container {
  padding: 0px !important;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(232, 232, 232, 1);

  h4 {
    font-size: 14px !important;
    font-weight: 550;
    line-height: 48px !important;
    color: #000;
    height: 48px !important;
    padding-left: 18px !important;
    margin-bottom: 0px !important;
  }
}

.el-range__icon {
  line-height: 24px !important;
}

.el-date-editor .el-range-separator {
  line-height: 27px !important;
}

.el-icon-time:before {
  position: absolute;
  top: 2px;
  left: 10px;
}

.adduser {
  margin-top: 7px !important;
  margin-right: 11px !important;
}

.el-range-separator {
  width: 11% !important;
}

.el-table {
  border: 1px solid #ebebeb;
}

.addSensorManagement-page .el-icon-date:before {
  position: absolute;
  top: 4px;
  left: 3px;
}

.el-tabs__item.is-left.is-active {
  background: #e7efff;
}

.el-tabs__active-bar.is-left {
  left: 0 !important;
  right: auto !important;
}

.el-table--fit {
  border-right: 1px solid #ebebeb !important;
}

.layoutBg {
  // background: url(~@/static/img/hejin.png) !important;
  min-height: 100vh;
}

.inputCen {
  input {
    text-align: center;
  }
}

.font_icon {
  position: absolute;
  top: 14px;
  margin-left: 7px;
  color: #ff7574;
}

.commit_textColor1 {
  color: #333 !important;
  font-size: 14px;
}

.currentMargin {
  margin-left: 8 !important;
}

.colorStatus {
  color: red;
}

.colorStatus1 {
  color: #666;
}

.icom_dailog_1 {
  position: relative;
  left: -10px;
  top: 18px;
}

.input_widthText {
  width: 420px !important;
}

.select-container .el-cascader .el-input .el-input__inner {
  background: #c4e5ff !important;
  color: #333 !important;
  border: none !important;
}

select {
  /*清除select默认样式*/

  width: 86px;
  line-height: 28px;
  height: 28px;
  border-radius: 3px;
  border: 1px solid #cdcdcd;
  text-align: center;
  color: #666;
}

.empty-box {
  text-align: center;
  padding: 70px;
  height: 400px;

  p {
    font-weight: 700;
    font-size: 20px;
    color: #999;
    position: relative;
    bottom: 29px;
  }
}

.control-box {
  width: 180px;
  background: #d9e0e6;
  border-radius: 4px;
  height: 24px;

  .control-box-item {
    text-align: center;
    color: #666;
    float: left;
    width: 60px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
  }

  .active {
    color: #fff !important;
    background: #226cff;
    border-radius: 4px;
  }
}
</style>
